import jss from "jss";
import React, { createContext, useContext, useEffect } from "react";
import { ethInstance as ethereumConnection } from "./ethereum";
import preset from "jss-preset-default";
import icon from './assets/logout.svg';
jss.setup(preset());
const styles = {
    button: {
        border: "none",
        fontSize: 16,
        fontWeight: 600,
        opacity: 0.7,
        fontFamily: "WorkSans",
        backgroundColor: "transparent",
        borderRadius: 0,
        margin: "0 8px",
        cursor: "pointer",
        transition: 'opacity 200ms',
        "&:hover": {
            opacity: 1,
            cursor: "pointer",
        },
    },
    img: {
        width: "20px"
    }
};
const { classes } = jss.createStyleSheet(styles).attach();
const DisconnectWalletContext = createContext({});
const DisconnectWalletButton = () => {
    const ctx = useContext(DisconnectWalletContext);
    const disconnect = async () => {
        await ctx.ethereumConnection.disconnectWallet();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { onClick: disconnect, className: classes.button, title: 'Logout' },
            React.createElement("img", { src: icon, className: classes.img }))));
};
const DisconnectWallet = ({ onDisconnect = () => { } }) => {
    useEffect(() => {
        document.addEventListener("account_changed", onDisconnect);
    }, []);
    const ContextState = {
        ethereumConnection,
    };
    return (React.createElement(DisconnectWalletContext.Provider, { value: ContextState },
        React.createElement(DisconnectWalletButton, null)));
};
export default DisconnectWallet;
